@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.bankilytransfers

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.bankilytransfers.ExtendedBankilyTransferDto
import com.narbase.letsgo.web.models.TransferType

object GetBankilyTransfersEndpoint : EndPoint<GetBankilyTransfersEndpoint.Request, GetBankilyTransfersEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String,
        val unassigned: Boolean?,
        @Suppress("NON_EXPORTABLE_TYPE") val type: DtoName<TransferType>?
    )

    class Response(
        val extendedBankilyTransfers: Array<ExtendedBankilyTransferDto>,
    )
}